// export const API_URL = `http://103.133.214.210:3030/`
export const API_URL = "https://sdgapi.dlearners.in/";
export const LOCAL_API_URL = "https://sdgapi.dlearners.in/";